import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Map, List, fromJS } from 'immutable';

import * as declareActions from 'modules/declare';
import * as currentStatusActions from 'modules/currentStatus';

import { DeclareContent } from 'components';

let resizeDeclare;
let SEARCH_VALUE = '';
class CtDeclareContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isLoadingExam: false,
      declareScrollData: { isScroll: false, height: 400 },
      searchText: '',
      tempFilter: {},
      filterUpdate: true
    };
  }

  componentDidMount() {
    // this.onGetDeclare(true);
    // this.onGetDeclareExam();
    window.addEventListener('resize', this.onResize);
  }

  // 태그 선택시 대상자 rerender 처리
  componentDidUpdate(prevProps, prevState) {
    // 대상자 Height 설정
    // 데이터가 없으면 rf.scrollable이 아예 생성 안됨
    const rf = this.refScroll;
    if (!!rf && !!rf.scrollable) {
      const { heightData, numberOfChildren } = rf.state.infiniteComputer;
      const isScroll = heightData * numberOfChildren > rf.scrollable.parentElement.clientHeight;

      // 높이가 달라진 경우
      // 스크롤이 생성 여부
      if (
        rf.computedProps.containerHeight !== rf.scrollable.parentElement.clientHeight ||
        isScroll !== this.state.declareScrollData['isScroll']
      ) {
        this.setState({
          declareScrollData: { isScroll: isScroll, height: rf.scrollable.parentElement.clientHeight }
        });
      }
    }

    const { needReload, selectedTag, declareParam, examNoArray, currentPath, declareRefresh, multiType } = this.props;

    if (
      // 훈련/메일 탭 변경 시
      currentPath !== prevProps.currentPath ||
      // 새로고침 버튼 클릭 시
      declareRefresh !== prevProps.declareRefresh) {
      const { DeclareActions } = this.props;
      DeclareActions.changeDeclare({
        name: 'examNoArray',
        value: List(['all'])
      });
      this.onFilterCancel();
    }

    if (
      // 대상자 새로고침
      (needReload && !this.state.isLoading) ||
      // 선택한 태그가 변경되었을 때
      selectedTag !== prevProps.selectedTag ||
      // parameter가 변경되었을때
      declareParam !== prevProps.declareParam ||
      // 선택한 훈련이 변경되었을때
      examNoArray !== prevProps.examNoArray ||
      // 여러 태그 선택 타입이 변경되었을 때
      multiType !== prevProps.multiType
    ) {
      if (currentPath === '/main/declaration/exam') {
        this.onGetDeclareExam();
        this.onGetDeclare(true);
      } else {
        this.onGetDeclareMail(true);
      }

      // 새로고침시 스크롤 맨위로 이동
      if (!!rf && !!rf.scrollable) {
        rf.scrollable.scrollTop = 0;
        // rf.infiniteHandleScroll(0);
        // rf.handleScroll(0);
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
    this.onFilterCancel();
    this.onSelectExamInit();
  }

  // 브라우저 리사이즈시의 처리
  onResize = () => {
    clearTimeout(resizeDeclare);
    resizeDeclare = setTimeout(() => {
      this.forceUpdate();
    }, 300);
  };

  // 훈련 조회
  onGetDeclareExam = async () => {
    if (!this.state.isLoadingExam) {
      this.setState({ isLoadingExam: true });
      try {
        const { DeclareActions } = this.props;

        await DeclareActions.getDeclareExam();
      } catch (e) {
        console.log(e);
      }

      this.setState({ isLoadingExam: false });
    }
  };

  // 신고 대상자 리스트 - 훈련 탭
  onGetDeclare = async refresh => {
    if (!this.state.isLoading) {
      this.setState({ isLoading: true });

      try {
        const {
          DeclareActions,
          CurrentStatusActions,
          examNoArray,
          selectedTag,
          declareParam,
          page,
          totalPages,
          multiType
        } = this.props;

        const tagNoArray =
          (selectedTag.toJS().toString() === 'all-tag' && 'all-tag') ||
          (selectedTag.toJS().toString() === 'no-tag' && 'no-tag') ||
          JSON.stringify(selectedTag);

        const examNoArrays = (examNoArray.toJS().toString() === 'all' && 'all') || JSON.stringify(examNoArray);

        if (refresh) {
          const param = {
            tagNoArray: tagNoArray,
            examNoArray: examNoArrays,
            filter: JSON.stringify(declareParam.get('filter')),
            sort: JSON.stringify(declareParam.get('sort')),
            offset: 0,
            limit: declareParam.get('limit'),
            refresh: !!refresh,
            multiType: multiType
          };

          // 선택한 대상 초기화
          CurrentStatusActions.selectDeclareTargetNo(0);

          await DeclareActions.getDeclare(param);

          setTimeout(() => {
            !!this.refScroll && !!this.refScroll.scrollable && this.refScroll.handleScroll(0);
          }, 500);
        } else if (totalPages > page) {
          const param = {
            tagNoArray: tagNoArray,
            examNoArray: examNoArrays,
            filter: JSON.stringify(declareParam.get('filter')),
            sort: JSON.stringify(declareParam.get('sort')),
            offset: declareParam.get('limit') * page,
            limit: declareParam.get('limit'),
            multiType: multiType
          };

          await DeclareActions.getDeclare(param);
        }

        !!declareParam.getIn(['filter', 'searchAll']) &&
          this.setState({ searchText: declareParam.getIn(['filter', 'searchAll']) });
      } catch (e) {
        console.log(e);
      }

      this.setState({ isLoading: false });
    }
  };

  // 신고 대상자 리스트 - 메일 탭
  onGetDeclareMail = async refresh => {
    if (!this.state.isLoading) {
      this.setState({ isLoading: true });

      try {
        const {
          DeclareActions,
          CurrentStatusActions,
          examNoArray,
          selectedTag,
          declareParam,
          page,
          totalPages,
          multiType
        } = this.props;

        const tagNoArray =
          (selectedTag.toJS().toString() === 'all-tag' && 'all-tag') ||
          (selectedTag.toJS().toString() === 'no-tag' && 'no-tag') ||
          JSON.stringify(selectedTag);

        if (refresh) {
          const param = {
            tagNoArray: tagNoArray,
            examNoArray: 'all',
            filter: JSON.stringify(declareParam.get('filter')),
            sort: JSON.stringify(declareParam.get('sort')),
            offset: 0,
            limit: declareParam.get('limit'),
            refresh: !!refresh,
            multiType: multiType
          };

          // 선택한 대상 초기화
          CurrentStatusActions.selectDeclareTargetNo(0);

          await DeclareActions.getDeclareMail(param);

          setTimeout(() => {
            !!this.refScroll && !!this.refScroll.scrollable && this.refScroll.handleScroll(0);
          }, 500);
        } else if (totalPages > page) {
          const param = {
            tagNoArray: tagNoArray,
            examNoArray: 'all',
            filter: JSON.stringify(declareParam.get('filter')),
            sort: JSON.stringify(declareParam.get('sort')),
            offset: declareParam.get('limit') * page,
            limit: declareParam.get('limit'),
            multiType: multiType
          };

          await DeclareActions.getDeclareMail(param);
        }

        !!declareParam.getIn(['filter', 'searchAll']) &&
          this.setState({ searchText: declareParam.getIn(['filter', 'searchAll']) });
      } catch (e) {
        console.log(e);
      }

      this.setState({ isLoading: false });
    }
  };

  // 대상자 정렬
  onSortOrdering = e => {
    const { DeclareActions, declareParam } = this.props;

    let orderValue = 'DESC';
    if (declareParam.get('sort')[0]['order'] === 'DESC') {
      orderValue = 'ASC';
    }
    DeclareActions.changeDeclareParam({
      name: 'sort',
      value: [{ order: orderValue, field: declareParam.get('sort')[0]['field'] }]
    });
  };

  // 대상자 정렬
  onSortDeclare = (e, data) => {
    const { DeclareActions, declareParam } = this.props;

    DeclareActions.changeDeclareParam({
      name: 'sort',
      value: [{ field: data.value, order: declareParam.get('sort')[0]['order'] }]
    });
  };

  // 대상자 검색
  onSearchDeclare = e => {
    let searchValue = '';
    if (e.key === 'Enter' || e.target.id === 'bt-searchTarget' || e.target.parentNode.id === 'bt-searchTarget') {
      searchValue = SEARCH_VALUE;

      const { DeclareActions, declareParam } = this.props;
      const filter = declareParam.get('filter').toJS();
      if (searchValue !== filter['searchAll']) {
        // filter 지우기
        if (searchValue === '') {
          delete filter['searchAll'];
        } else {
          filter['searchAll'] = searchValue;
        }

        DeclareActions.changeDeclareParam({
          name: 'filter',
          value: fromJS(filter)
        });
      }
    }
  };

  // 스크롤 ref 등록
  onRefScroll = Scroll => {
    if (!!Scroll) {
      this.refScroll = Scroll;
    }
  };

  // 최근 훈련 결과 필터
  onFilterExamInfo = data => {
    const { tempFilter } = this.state;
    const filter = Object.assign({}, tempFilter);

    if (typeof filter['examInfoArray'] === 'undefined') {
      filter['examInfoArray'] = [data.value];
    } else {
      const indexArray = filter['examInfoArray'].findIndex(filterItem => filterItem === data.value);
      if (indexArray === -1) {
        filter['examInfoArray'].push(data.value);
      } else {
        filter['examInfoArray'].splice(indexArray, 1);
        // 필터 array가 없다면 삭제
        filter['examInfoArray'].length === 0 && delete filter['examInfoArray'];
      }
    }

    this.setState({
      tempFilter: filter,
      filterUpdate: false
    });
  };

  // 소속 필터
  onFilterDivision = data => {
    const { tempFilter } = this.state;
    const filter = Object.assign({}, tempFilter);

    if (typeof filter['declareDivisionArray'] === 'undefined') {
      filter['declareDivisionArray'] = [data.value];
    } else {
      const indexArray = filter['declareDivisionArray'].findIndex(filterItem => filterItem === data.value);
      if (indexArray === -1) {
        filter['declareDivisionArray'].push(data.value);
      } else {
        filter['declareDivisionArray'].splice(indexArray, 1);
        // 필터 array가 없다면 삭제
        filter['declareDivisionArray'].length === 0 && delete filter['declareDivisionArray'];
      }
    }

    this.setState({
      tempFilter: filter,
      filterUpdate: false
    });
  };

  // 직급 필터
  onFilterPosition = data => {
    const { tempFilter } = this.state;
    const filter = Object.assign({}, tempFilter);

    if (typeof filter['declarePositionArray'] === 'undefined') {
      filter['declarePositionArray'] = [data.value];
    } else {
      const indexArray = filter['declarePositionArray'].findIndex(filterItem => filterItem === data.value);
      if (indexArray === -1) {
        filter['declarePositionArray'].push(data.value);
      } else {
        filter['declarePositionArray'].splice(indexArray, 1);
        // 필터 array가 없다면 삭제
        filter['declarePositionArray'].length === 0 && delete filter['declarePositionArray'];
      }
    }

    this.setState({
      tempFilter: filter,
      filterUpdate: false
    });
  };

  // 필터 초기화
  onFilterCancel = () => {
    const { DeclareActions } = this.props;

    DeclareActions.changeDeclareParam({
      name: 'filter',
      value: Map({})
    });

    if (this.myTextInput && this.myTextInput.inputRef.value !== '') {
      this.myTextInput.inputRef.value = '';
    }
  };

  onSelectExamInit = () => {
    const { DeclareActions } = this.props;

    DeclareActions.changeDeclare({
      name: 'examNoArray',
      value: List(['all'])
    });
  };

  // 대상자 선택
  handleSelectDeclare = declareTargetNo => {
    const { CurrentStatusActions } = this.props;
    CurrentStatusActions.selectDeclareTargetNo({ declareTargetNo });
  };

  // 검색 입력값 받아오기
  takeSearchValue = searchValue => {
    SEARCH_VALUE = searchValue;
  };

  searchTextRef = ref => {
    this.myTextInput = ref;
  };

  //필터 팝업 클로즈
  filterClose = () => {
    const { declareParam } = this.props;
    const filter = declareParam.get('filter').toJS();

    this.setState({
      tempFilter: filter,
      isLoading: false,
      filterUpdate: true
    });
  };

  //체크한 필터 실행
  excuteFilter = () => {
    const { DeclareActions } = this.props;
    const { tempFilter } = this.state;
    const filter = tempFilter;

    this.setState({ currentPage: 0 });
    this.setState({ filterUpdate: true });
    DeclareActions.changeDeclareParam({
      name: 'filter',
      value: fromJS(filter)
    });
  };

  // 검색 타입 선택
  handleSelectOptions = (e, { value }) => {
    const { DeclareActions } = this.props;

    DeclareActions.changeDeclare({
      name: 'examNoArray',
      value: List([value])
    });
  };

  render() {
    const {
      selectDeclareTargetNo,
      selectedTag,
      tagDataByTagNo,
      declareOrdering,
      declareDataByTargetNo,
      declareParam,
      declareFilter,
      page,
      totalPages,
      totalDeclare,
      currentPath
    } = this.props;
    // function
    const {
      onGetDeclare,
      onGetDeclareExam,
      onGetDeclareMail,
      onSortDeclare,
      onSearchChange,
      onSearchDeclare,
      handleSelectDeclare,
      onRefScroll,
      onFilterExamInfo,
      onFilterDivision,
      onFilterPosition,
      onFilterCancel,
      onSelectExamInit,
      onSortOrdering,
      takeSearchValue,
      searchTextRef,
      filterClose,
      excuteFilter,
      handleSelectOptions
    } = this;
    const { tempFilter, filterUpdate, isLoading, searchText } = this.state;
    return (
      <DeclareContent
        tagDataByTagNo={tagDataByTagNo}
        declareOrdering={declareOrdering}
        declareDataByTargetNo={declareDataByTargetNo}
        declareParam={declareParam}
        selectDeclareTargetNo={selectDeclareTargetNo}
        selectedTag={selectedTag}
        declareScrollData={this.state.declareScrollData}
        isLoading={isLoading}
        page={page}
        totalPages={totalPages}
        totalDeclare={totalDeclare}
        onGetDeclare={onGetDeclare}
        onGetDeclareExam={onGetDeclareExam}
        onGetDeclareMail={onGetDeclareMail}
        onSortDeclare={onSortDeclare}
        onSortOrdering={onSortOrdering}
        onSearchChange={onSearchChange}
        onSearchDeclare={onSearchDeclare}
        handleSelectDeclare={handleSelectDeclare}
        onRefScroll={onRefScroll}
        // 필터
        searchText={searchText}
        declareFilter={declareFilter}
        onFilterExamInfo={onFilterExamInfo}
        onFilterDivision={onFilterDivision}
        onFilterPosition={onFilterPosition}
        onFilterCancel={onFilterCancel}
        onSelectExamInit={onSelectExamInit}
        takeSearchValue={takeSearchValue}
        searchTextRef={searchTextRef}
        excuteFilter={excuteFilter}
        filterClose={filterClose}
        tempFilter={tempFilter}
        filterUpdate={filterUpdate}
        currentPath={currentPath}
        handleSelectOptions={handleSelectOptions}
      />
    );
  }
}

const mapStateToProps = state => ({
  needReload: state.declare.get('needReload'),
  examNoArray: state.declare.get('examNoArray'),
  page: state.declare.get('page'),
  totalPages: state.declare.get('totalPages'),
  totalDeclare: state.declare.get('totalDeclare'),
  declareOrdering: state.declare.get('declareOrdering'),
  declareDataByTargetNo: state.declare.get('declareDataByTargetNo'),
  declareParam: state.declare.get('param'),
  declareFilter: state.declare.get('filter'),
  tagDataByTagNo: state.tag.get('tagDataByTagNo'),
  selectedTag: state.currentStatus.getIn(['tag', 'selectedTag']),
  selectDeclareTargetNo: state.currentStatus.getIn(['declare', 'selectDeclareTargetNo']),
  currentPath: state.currentStatus.getIn(['path', 'current']),
  multiType: state.currentStatus.getIn(['tag', 'multiType']),
  declareRefresh: state.declare.get('declareRefresh')
});

const mapDispatchToProps = dispatch => ({
  DeclareActions: bindActionCreators(declareActions, dispatch),
  CurrentStatusActions: bindActionCreators(currentStatusActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CtDeclareContent);



// WEBPACK FOOTER //
// ./src/script/containers/declare/CtDeclareContent.js